import { Box, Spinner } from '@chakra-ui/react';
import React from 'react';
import './styles.scss';
import { useLoader } from '@store/loader';
import { ConditionalComponent } from '@components/functionComponent';

const Loader = () => {
    const { isLoadingPage } = useLoader();
    return (
        <ConditionalComponent statement={isLoadingPage}>
            <Box className="global-loader__container" data-testid="global-loader">
                <Box className="spinner-box">
                    <Spinner size="md" color="white" data-testid="spinner-loader" />
                </Box>
            </Box>
        </ConditionalComponent>
    );
};

export default Loader;
